import api from './api';

export const getRecipeNotesGuidance = async () => {
  const response = await api.get('/recipe-notes-guidance');
  return response.data;
};

export const updateRecipeNotesGuidance = async (text) => {
  const response = await api.put('/recipe-notes-guidance/admin', { text });
  return response.data;
};
